import { render, staticRenderFns } from "./UserMedia.vue?vue&type=template&id=f9c85788&scoped=true"
import script from "./UserMedia.vue?vue&type=script&lang=js"
export * from "./UserMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c85788",
  null
  
)

export default component.exports